import { PagerRequestI } from '@tacans/shared-marketplace-layer';

export const defaultPagerRequest: PagerRequestI = {
    page: 0,
    limit: 10,
};

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
